import { clsx } from 'clsx'
import { useContext, type ReactElement } from 'react'

import { useGetAuthAndDeviceTypeCta } from '@lib/hooks/auth-and-device-type-cta'

import {
  CtaGroupLayout,
  type TypeComponentCtaGroupEntry,
} from '@contentful-types/component-cta-group'

import { CtaDescriptionPosition } from '@constants/enums/cta'

import {
  CtaButtonContext,
  CtaButtonMetadataProvider,
  DefaultCtaButtonContext,
} from '@contexts/cta-button-context'

import { CtaButton, CtaButtonDescription } from '../cta-button/cta-button'

import styles from './cta-group.module.scss'

export function ComponentCtaGroup({
  data,
  inline,
}: {
  data: TypeComponentCtaGroupEntry
  inline?: boolean
}): ReactElement {
  const {
    fields: { ctAs, layout = CtaGroupLayout.Row, internalName },
  } = data

  const { getAuthAndDeviceTypeCta } = useGetAuthAndDeviceTypeCta()
  const { showCtaDescription, descriptionPosition, descriptionWidth } = useContext(CtaButtonContext)
  const authAndDeviceTypeCtas = ctAs.filter(Boolean).map(cta => getAuthAndDeviceTypeCta(cta!))
  const firstCtaWithDescription = authAndDeviceTypeCtas.find(
    cta => cta.fields.ctaUnderDescription != undefined,
  )
  return (
    <>
      <div
        className={clsx(
          styles.container,
          layout === CtaGroupLayout.Column ? styles.column : styles.row,
          descriptionPosition === CtaDescriptionPosition.Left ? styles.left : styles.center,
        )}
        data-component-id={internalName}
      >
        {authAndDeviceTypeCtas.map(cta => (
          <CtaButtonMetadataProvider
            key={cta.sys.id}
            value={{
              ...DefaultCtaButtonContext,
              descriptionPosition,
              descriptionWidth,
              showCtaDescription: false,
            }}
          >
            <CtaButton key={cta.sys.id} data={cta} inline={inline} />
          </CtaButtonMetadataProvider>
        ))}
      </div>

      {showCtaDescription && firstCtaWithDescription ? (
        <CtaButtonDescription data={firstCtaWithDescription} />
      ) : (
        <></>
      )}
    </>
  )
}
